import { PasswordNeedsChangeCheck } from "@/components/authentication/PasswordNeedsChangeCheck";
import { Loading } from "@/components/overlays/Loading";
import { store } from "@/store";
import { supabaseApi, useGetAssuranceLevelQuery, useGetCurrentUserQuery } from "@/store/services/supabase";
import { currentPathWithQuery, loginHref } from "@/utils/url";
import { useSession, useSupabaseClient } from "@supabase/auth-helpers-react";
import { useRouter } from "next/router";
import { useEffect } from "react";
export const AuthCheck = ({
  children
}: {
  children: JSX.Element;
}) => {
  const router = useRouter();
  const session = useSession();
  const supabase = useSupabaseClient();
  const {
    data: assuranceLevel,
    refetch: refetchAssuranceLevel
  } = useGetAssuranceLevelQuery();
  const {
    data: user
  } = useGetCurrentUserQuery();

  /** Sign in, then come back to the page they were actually after. */
  const redirectToLogin = () => router.push(loginHref(currentPathWithQuery()));
  useEffect(() => {
    refetchAssuranceLevel().then(({
      data
    }) => {
      if (!data || !data.hasVerifiedMFA) {
        redirectToLogin();
      }
    });
  }, []);
  useEffect(() => {
    const sessionUserId = session?.user?.id;
    if (!sessionUserId || user?.id === sessionUserId) return;
    store.dispatch(supabaseApi.endpoints.getCurrentUser.initiate(undefined, {
      forceRefetch: true
    }));
  }, [session?.user?.id, user?.id]);
  useEffect(() => {
    if (!session) {
      redirectToLogin();
    }
    const {
      data: authListener
    } = supabase.auth.onAuthStateChange(event => {
      console.log(`Supabase auth event: ${event}`);
      if (event === "SIGNED_OUT") {
        localStorage.clear();
        sessionStorage.clear();
      }
    });
    return () => {
      authListener.subscription.unsubscribe();
    };
  }, [session]);
  if (!session || !assuranceLevel || !assuranceLevel.hasVerifiedMFA) {
    return <Loading />;
  }
  return <PasswordNeedsChangeCheck data-sentry-element="PasswordNeedsChangeCheck" data-sentry-component="AuthCheck" data-sentry-source-file="AuthCheck.tsx">{children}</PasswordNeedsChangeCheck>;
};